import script from "./ProfileDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&setup=true&lang=js"

import "./ProfileDetails.vue?vue&type=style&index=0&id=0eaa7074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0eaa7074"]])

export default __exports__